module.exports = __webpack_public_path__ + "09_mole.e4a29b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/09_mole.png
// module id = 4uwH
// module chunks = 0